// extracted by mini-css-extract-plugin
module.exports = {"Content":"Layout_Content__4Tjck","NavText":"Layout_NavText__3Crib","Footer":"Layout_Footer__3D8J5"};